let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("g6nHD")).then(() => parcelRequire('i0vin'));